@if (hasAccess) {
  <div class="padding">
    <h1 class="left-box">{{ 'common.labels.newUser' | transloco }}</h1>
    <mat-card>
      <mat-card-content>
        <div class="flex-container padding-top">
          <div class="flex-item form-field">
            <mat-radio-group [(ngModel)]="this.newUser.userTypeID" [attr.aria-label]="'management.lienTermOrInfiniteLienRadio' | transloco">
              <mat-radio-button class="radio-button" [value]="apiUserType" (change)="onUserTypeSelectionChange($event)">{{ 'common.labels.api' | transloco }}</mat-radio-button>
              <mat-radio-button class="radio-button" [value]="portalUserType" (change)="onUserTypeSelectionChange($event)">{{ 'common.labels.clientPortal' | transloco }}</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        @if (newUser.userTypeID == portalUserType) {
          <div class="flex-container padding">
            <div class="flex-item form-field">
              <mat-slide-toggle [(ngModel)]="this.newUser.isTwoFactorEnabled">{{ 'common.labels.multiFactorAuthentication' | transloco }}</mat-slide-toggle>
            </div>
          </div>
        }
        <div class="flex-container">
          <mat-form-field appearance="outline" class="flex-item">
            <mat-label>{{ 'common.labels.firstName2' | transloco }}</mat-label>
            <input matInput name="firstName"[(ngModel)]="this.newUser.firstName" [placeholder]="'common.labels.firstName2' | transloco">
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-item">
            <mat-label>{{ 'common.labels.middleName' | transloco }}</mat-label>
            <input matInput name="middleName"[(ngModel)]="this.newUser.middleName" [placeholder]="'common.labels.middleName' | transloco">
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-item">
            <mat-label>{{ 'common.labels.lastName2' | transloco }}</mat-label>
            <input matInput name="lastName"[(ngModel)]="this.newUser.lastName" [placeholder]="'common.labels.lastName2' | transloco">
          </mat-form-field>
        </div>
        <div class="flex-container">
          <mat-form-field appearance="outline" class="flex-item">
            <mat-label>{{ 'management.username' | transloco }}</mat-label>
            <input matInput name="username" [(ngModel)]="this.newUser.userName" [placeholder]="'management.username' | transloco">
          </mat-form-field>
        </div>
        <div class="flex-container">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>{{ (passwordLabelKeys[passwordFieldLabel] ?? passwordFieldLabel) | transloco }}</mat-label>
            <input matInput name="password" [type]="hidePassword ? 'password' : 'text'" [(ngModel)]="this.newUser.password" [placeholder]="(passwordLabelKeys[passwordFieldLabel] ?? passwordFieldLabel) | transloco" autocomplete="new-password">
            <button type="button" mat-icon-button matSuffix (click)="togglePasswordVisibility()"
              [attr.aria-label]="(hidePassword ? 'common.labels.showPassword' : 'common.labels.hidePassword') | transloco"
              [attr.aria-pressed]="!hidePassword">
              <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="flex-container">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>{{ (passwordLabelKeys[confirmPasswordFieldLabel] ?? confirmPasswordFieldLabel) | transloco }}</mat-label>
            <input matInput name="password" [type]="hidePassword ? 'password' : 'text'" [(ngModel)]="confirmPassword" [placeholder]="(passwordLabelKeys[confirmPasswordFieldLabel] ?? confirmPasswordFieldLabel) | transloco" autocomplete="new-password">
            <button type="button" mat-icon-button matSuffix (click)="togglePasswordVisibility()"
              [attr.aria-label]="(hidePassword ? 'common.labels.showPassword' : 'common.labels.hidePassword') | transloco"
              [attr.aria-pressed]="!hidePassword">
              <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="flex-container">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>{{ 'management.configurationOverrideOptional' | transloco }}</mat-label>
            <mat-select name="configuration" [(ngModel)]="this.newUser!.configurationDetailsID">
              @for (configuration of configurationDetailsOptions; track configuration) {
                <mat-option [value]="configuration.id">
                  {{configuration.name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <h3>{{ 'common.labels.contactInformation' | transloco }}</h3>
        <app-client-contact-details-card [contactDetails]="newUser!.contactDetails" [emailRequired]="true"></app-client-contact-details-card>
        <div class="flex-container">
          <span class="spacer"></span>
          <button mat-raised-button (click)="saveUser()" color="accent" class="apply-padding" [attr.aria-label]="'management.saveUserButton' | transloco">
            {{ 'common.buttons.save' | transloco }}
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
}